import React from "react";
import Box from "@mui/material/Box";
import MiniSidebar from "../layout/miniSidebar";

const UserProfile = ({ comp, isTailwindComponent = false }) => {
  return (
    <Box>
      <MiniSidebar comp={comp} isTailwindComponent={isTailwindComponent} />
    </Box>
  );
};

export default UserProfile;
